import { css } from 'emotion'

export const TaskStatusSelectFieldStyles = css``
